/**
 * @flow
 */

import {
  QUESTIONNAIRE_STEP,
  UPDATE_PROGRESS_STEP,
  UPDATE_CREATE_FIELD,
  UPDATE_LOCATION,
  UPDATE_PROGRESS_STATUS,
  VALIDATE_CREATE_FORM,
  SET_EVENT_TYPE,
  SET_SOCIAL_IMAGE,
  SET_COVER_IMAGE,
  CLEAR_COVER_IMAGE,
  CLEAR_SOCIAL_IMAGE
} from './actions';

const initialState = {
  currentStep: QUESTIONNAIRE_STEP,
  eventType: '',
  eventName: '',
  eventDescription: '',
  eventCategory: '',
  eventTicketName: '',
  eventCapacity: '',
  eventTicketPrice: '',
  eventDisplayCurrency: '',
  eventTransactedCurrency: '',
  eventContactDetails: '',
  eventSocialImage: '',
  eventCoverImage: '',
  eventPublicUnlisted: 'public',
  formValid: true,
  progressBasics: 'neutral',
  progressWhenWhere: 'neutral',
  progressTickets: 'neutral',
  progressStatus: {
    basics: 'neutral',
    whenwhere: 'neutral',
    tickets: 'neutral'
  },
  coverImage: null,
  socialImage: null
};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {
    case CLEAR_COVER_IMAGE:
      return Object.assign({}, state, {
        coverImage: null,
        eventCoverImage: ''
      });

    case CLEAR_SOCIAL_IMAGE:
      return Object.assign({}, state, {
        socialImage: null,
        eventSocialImage: ''
      });

    case SET_EVENT_TYPE:
      return Object.assign({}, state, {
        eventType: action.payload.type
      });

    case SET_SOCIAL_IMAGE:
      return Object.assign({}, state, {
        eventSocialImage: action.payload.image,
        socialImage: action.payload.url
      });

    case SET_COVER_IMAGE:
      return Object.assign({}, state, {
        eventCoverImage: action.payload.image,
        coverImage: action.payload.url
      });

    case UPDATE_PROGRESS_STEP:
      return Object.assign({}, state, {
        currentStep: action.payload.nextStep
      });

    case VALIDATE_CREATE_FORM:
      const newProgressStatus = state.progressStatus;
      let newProgressBasics = state.progressBasics;
      let newProgressWhenWhere = state.progressWhenWhere;
      let newProgressTickets = state.progressTickets;

      let formValid = true;
      const {
        eventType,
        eventName,
        eventDescription,
        eventCategory,
        eventAddress,
        eventLatitude,
        eventLongitude,
        eventStartTime,
        eventStartDate,
        eventEndTime,
        eventEndDate,
        eventTicketName,
        eventTicketPrice,
        eventDisplayCurrency,
        eventTransactedCurrency
      } = state;

      if (action.payload.page === 'basics') {
        if (eventName && eventDescription && eventCategory) {
          newProgressStatus.basics = 'success';
          newProgressBasics = 'success';
        }
        else {
          formValid = false;
          newProgressStatus.basics = 'error';
          newProgressBasics = 'error';
        }
      }

      if (action.payload.page ===  'whenwhere') {
        if (eventAddress && eventLatitude && eventLongitude && eventStartTime && eventStartDate && eventEndTime && eventEndDate) {
          newProgressStatus.whenwhere = 'success';
          newProgressWhenWhere = 'success';
        }
        else {
          formValid = false;
          newProgressStatus.whenwhere = 'error';
          newProgressWhenWhere = 'error';
        }
      }

      if (action.payload.page ===  'tickets') {
        if (eventType === 'PAID_EVENT_TYPE') {
          if (eventTicketName && eventTicketPrice && eventDisplayCurrency && eventTransactedCurrency) {
            newProgressStatus.tickets = 'success';
            newProgressTickets = 'success';
          }
          else {
            formValid = false;
            newProgressStatus.tickets = 'error';
            newProgressTickets = 'error';
          }
        }
        else {
          if (eventTicketName) {
            newProgressStatus.tickets = 'success';
            newProgressTickets = 'success';
          }
          else {
            formValid = false;
            newProgressStatus.tickets = 'error';
            newProgressTickets = 'error';
          }
        }
      }

      return { ...state,
        formValid,
        progressBasics: newProgressBasics,
        progressWhenWhere: newProgressWhenWhere,
        progressTickets: newProgressTickets,
        progressStatus: newProgressStatus
      };

    case UPDATE_CREATE_FIELD:
      const changedInput = {};
      changedInput[action.payload.input] = action.payload.value;
      return { ...state, ...changedInput };

    case UPDATE_LOCATION:
      return Object.assign({}, state, {
        eventAddress: action.payload.eventAddress,
        eventLatitude: action.payload.eventLatitude,
        eventLongitude: action.payload.eventLongitude
      });

    case UPDATE_PROGRESS_STATUS:
      return Object.assign({}, state, {
        progressStatus: Object.assign({}, state.progressStatus, action.payload)
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/create/reducer.js